import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import ReactLoading from 'react-loading';
import Switch from 'react-switch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import Hash from 'object-hash';

import './Audit.css';
import RuleForm from '../RuleForm/RuleForm';
import { formatSubmittedRule, toTitleCase } from '../../util/util';

class Audit extends Component {
    state = {
        deleteClicked: false
    };

    componentDidMount() {
        if (!this.props.rules || this.props.rules.length < 1) {
            this.props.fetchRules();
        }
        this.setState({ location: this.props.location.pathname });
    }

    submit = async (formValues) => {
        console.log("Audit Rule Form Values", formValues);
        let ruleToUpdate = formatSubmittedRule(this.getRuleToRender());
        let formRule = formatSubmittedRule(formValues);
        let formRuleWorktags = formRule['worktags'];
        let updatedTime = (new Date()).toISOString();

        let deleted = Object.keys(ruleToUpdate.worktags).filter(function (elem) {
            return Object.keys(formRuleWorktags).indexOf(elem) <= -1;
        });
        let added = Object.keys(formRuleWorktags).filter(function (elem) {
            return Object.keys(ruleToUpdate.worktags).indexOf(elem) <= -1;
        });

        let audit = [...Object.values(ruleToUpdate.audit || {})];

        for (let keyName in formRuleWorktags) {
            let wasUpdated = ruleToUpdate.worktags[keyName] ? ruleToUpdate.worktags[keyName].toString() : null !== formRuleWorktags[keyName].toString();
            let newAuditObj;
            if (added.includes(keyName)) {
                newAuditObj = { updatedTime, message: `${toTitleCase(keyName)} worktag with value of ${formRuleWorktags[keyName]} was created by current user.` };
            } else if (wasUpdated) {
                newAuditObj = { updatedTime, message: `${toTitleCase(keyName)} worktag was updated to ${formRuleWorktags[keyName]} from ${ruleToUpdate.worktags[keyName]} by current user.` };
            }
            if (newAuditObj) {
                console.log(newAuditObj.message);
                audit.push(newAuditObj);
            }
        }
        for (let key of deleted) {
            let newAuditObj = { updatedTime, message: `${toTitleCase(key)} worktag with value of ${ruleToUpdate.worktags[key]} was deleted by current user.` };
            audit.push(newAuditObj);
        }

        if (ruleToUpdate.area !== formRule.area) {
            let newAuditObj;
            if (!ruleToUpdate.area) {
                newAuditObj = { updatedTime, message: `Area with value of "${formRule.area}" was created by current user.` };
            } else if (ruleToUpdate.area && !formRule.area) {
                newAuditObj = { updatedTime, message: `Area with value of "${ruleToUpdate.area}" was deleted by current user.` };
            } else {
                newAuditObj = { updatedTime, message: `Area was updated to "${formRule.area}" from "${ruleToUpdate.area}" by current user.` };
            }
            audit.push(newAuditObj);
        }

        if (ruleToUpdate.description !== formRule.description) {
            let newAuditObj;
            if (!ruleToUpdate.description) {
                newAuditObj = { updatedTime, message: `Description with value of "${formRule.description}" was created by current user.` };
            } else if (ruleToUpdate.description && !formRule.description) {
                newAuditObj = { updatedTime, message: `Description with value of "${ruleToUpdate.description}" was deleted by current user.` };
            } else {
                newAuditObj = { updatedTime, message: `Description was updated to "${formRule.description}" from "${ruleToUpdate.description}" by current user.` };
            }
            audit.push(newAuditObj);
        }

        if (formRule.addComments) {
            let newAuditObj = { updatedTime, message: `Comment was added: "${formRule.addComments}" by current user.` };
            audit.push(newAuditObj);
        }

        const area = formRule.area || null;
        const description = formRule.description || null;

        //check if keys are updated
        console.log("form Rule: ", formRule);
        console.log("rule to update: ", ruleToUpdate);

        let indId = formRule.ind_id_no;
        let custRef = formRule.customer_ref;
        let origId = formRule.orig_id;
        let boCustomer = formRule.bo_customer;
        let vrn = formRule.vrn;

        if(!indId) indId = "";
        if(!custRef) custRef = "";
        if(!origId) origId = "";
        if(!boCustomer) boCustomer = "";
        if(!vrn) vrn = "";

        if (formRule.components.includes(indId) && formRule.components.includes(custRef) && formRule.components.includes(origId) && formRule.components.includes(boCustomer) && formRule.components.includes(vrn) && formRule.bank_account === ruleToUpdate.bank_account && formRule.type_code === ruleToUpdate.type_code) {
            audit.sort((a, b) => a.updatedTime > b.updatedTime ? 1 : -1);
            let updatedRule = Object.assign({}, ruleToUpdate, { worktags: formRuleWorktags, audit, area, description });
            console.log("formRule", formRule);
            console.log("updated rule from audit:", updatedRule);
            this.props.updateRules([updatedRule]);
            this.setState({ keysDidChange: false })
        }
        else {
            // a key value has been changed.
            // we must eliminate this record and create a new one
            console.log("form Values: ", formValues);
            delete formValues.components;
            delete formValues.components_search;
            let createdRule = formatSubmittedRule(formValues);
            if (!formRule.audit) { formRule.audit = []; }
            createdRule.audit = formRule.audit;
            createdRule.tran_account = createdRule.type_code+":"+createdRule.bank_account;
            this.props.updateKeyRule(createdRule, ruleToUpdate);
            let ruleId = Hash({ tran_account: createdRule.tran_account, components: createdRule.components });
            this.setState({
                keysDidChange: true,
                ruleId: ruleId,
                didRedirect: false
            })
        }
    };

    getRuleToRender = () => {
        let rule = Object.assign({}, this.props.rules.find((rule) => rule.id === this.props.match.params.id));
        console.log("Rule to Render", rule);
        if (rule.worktags && (Object.keys(rule.worktags).length > 0)) {
            let worktagsArray = [];
            console.log("Worktags", Object.keys(rule.worktags));
            for (let key in rule.worktags) {
                worktagsArray.push({ key: key, value: rule.worktags[key] });
            }
            rule.worktags = worktagsArray;
        }
        return rule;
    };

    handleInactiveToggle = (active, event, id) => {
        let rule = formatSubmittedRule(this.getRuleToRender());
        if (!rule.inactive !== active) {
            let updatedTime = (new Date()).toISOString();
            let audit = [...Object.values(rule.audit || {}), { updatedTime, message: `Rule was ${active ? "activated" : "inactivated"} by current user.` }];
            rule.inactive = !active;
            rule.audit = audit;
            this.props.updateRules([rule]);
        }
    };

    handleDeleteClick = (event) => {

        this.setState({
            areYouSure: true
        })

    };

    handleConfirmDeleteClick = (event) => {
        if (event.target.innerText === "Cancel") {
            this.setState({ areYouSure: false });
        }
        else {
            let ruleToDelete = formatSubmittedRule(this.getRuleToRender());
            this.setState(() => ({ deleteClicked: true }));
            this.props.deleteRule(ruleToDelete);
        }
    };

    render() {
        if (this.state.deleteClicked && !this.props.ruleDeleting) {
            return <Redirect to="/rules" />
        }
        if (!this.state.didRedirect && this.state.ruleId && !this.props.ruleSubmitting && !this.props.ruleDeleting && !this.props.invalidWorktags && this.state.keysDidChange === true) {
            console.log("redirecting to ", this.state.ruleId);
            this.setState({ didRedirect: true });
            return <Redirect to={`/audit/${this.state.ruleId}`} />
        }

        if (this.props.rules && this.props.rules.length > 0) {
            let initialValues = this.getRuleToRender();
            let isInitalValuesEmpty = Object.keys(initialValues).length === 0;
            return (
                <div>
                    <h1>Rule <small>{!initialValues.inactive ? "(active)" : "(inactive)"}</small></h1>
                    <RuleForm onSubmit={this.submit} submission={this.props.ruleSubmitting} initialValues={initialValues} isEdit={!isInitalValuesEmpty} invalidWorktags={this.props.invalidWorktags} />
                    <h4 className="mt-4">Usage</h4>
                    {this.state.areYouSure && (
                        <div className="row">
                            <div className="col-12 alert alert-danger d-flex justify-content-between">
                                <span className="align-self-center">
                                    Are you sure that you want to delete this rule?
                            </span>
                                <span className="justify-content-right">
                                    <button className="btn btn-danger mx-2" onClick={this.handleConfirmDeleteClick}>Yes</button>
                                    <button className="btn btn-danger mx-2" onClick={this.handleConfirmDeleteClick}>Cancel</button>
                                </span>
                            </div>
                        </div>
                    )}
                    <label htmlFor="active-switch">
                        <span>Rule Available For Processing </span>
                        <Switch
                            checked={!initialValues.inactive}
                            onChange={this.handleInactiveToggle}
                            className="react-switch"
                            id="active-switch"
                        />
                    </label>
                    <div className="mb-1 row">
                        <div className="ml-3">
                            # of times used: {initialValues.usage_count || 0}
                            {(initialValues.usage_count > 0) ||
                                <button
                                    className="btn btn-danger mx-2"
                                    onClick={this.handleDeleteClick}
                                    disabled={this.props.ruleDeleting}
                                >
                                    <FontAwesomeIcon icon={faExclamationTriangle} size="sm" /> Delete
                                </button>
                            }
                        </div>
                        {!this.props.ruleDeleting || (
                            <div>
                                <ReactLoading type={"spin"} color={"#666666"} height={'40px'} width={'40px'} />
                            </div>
                        )}
                    </div>
                    <div className="mb-4">Last used: {initialValues.last_used_date || "N/A"}</div>
                    <h4>Audit</h4>
                    <ul>
                        {Object.keys(initialValues.audit || {}).length ?
                            Object.keys(initialValues.audit).map((key) => (
                                <li key={key}>
                                    <div>{initialValues.audit[key].updatedTime}</div>
                                    <div>Message: {initialValues.audit[key].message}</div>
                                </li>
                            ))
                            :
                            <li>
                                No audit records.
                            </li>
                        }
                    </ul>
                </div>
            );
        } else {
            return (
                <div className="col-12 loader">
                    <ReactLoading type={"spin"} color={"#666666"} height={'15%'} width={'15%'} />
                </div>
            );
        }
    }
}

export default Audit;


// WEBPACK FOOTER //
// ./src/components/Audit/Audit.js